import useUserStore from '../stores/userStore'
import { RIGHTS } from '@interfaces/RightsEnum'
import { UserRights } from '@interfaces/User'
import { ROLES } from '@interfaces/RolesEnum'

export function authorizeRights(rights: RIGHTS[], mustHaveAll = false) {
  const userStore = useUserStore()

  if (mustHaveAll) {
    return allIn(userStore.getRights as UserRights, rights)
  } else {
    return atLeastOne(userStore.getRights as UserRights, rights)
  }
}
function atLeastOne(source: UserRights, target: RIGHTS[]): boolean {
  return !target || target.length === 0
    ? false
    : target.some((right) => source[right] === true)
}

function allIn(source: UserRights, target: RIGHTS[]): boolean {
  return !target || target.length === 0
    ? true
    : target.every((right) => source[right] === true)
}

export function authorizeRoles(requiredRoles: ROLES[]) {
  const userStore = useUserStore()
  const userRole = userStore.getRole as string
  return isUserInRequiredRoles(userRole, requiredRoles)
}

function isUserInRequiredRoles(userRole: string, requiredRoles: ROLES[]) {
  if (!userRole) {
    return false
  }
  const normalizedRole = normalizeRole(userRole)
  return requiredRoles.includes(normalizedRole as ROLES)
}

function normalizeRole(role: string): string {
  return role === ROLES.ADMIN_APNF
    ? role
    : role.replace('_RECEVABILITE', '')
}
